// Helper function
const constructDob = (abhaProfile) => {
    // Construct from separate fields (new format)
    const day = abhaProfile?.dayOfBirth;
    const month = abhaProfile?.monthOfBirth;
    const year = abhaProfile?.yearOfBirth;

    if (day && month && year) {
        // Ensure day and month are zero-padded
        const paddedDay = String(day).padStart(2, '0');
        const paddedMonth = String(month).padStart(2, '0');
        return `${year}-${paddedMonth}-${paddedDay}`;
    }

    return "";
};

// Factory function that uses abhaProfile context dynamically
export const getPatientRegistrationInitialValues = (abhaProfile) => ({
    full_name: `${abhaProfile?.firstName || ""} ${abhaProfile?.middleName || ""} ${abhaProfile?.lastName || ""}`.trim(),
    mobile: abhaProfile?.mobile || "",
    alternate_mobile: abhaProfile?.alternate_mobile || "",
    dob: constructDob(abhaProfile),
    gender: abhaProfile?.gender === "M" ? "Male" : abhaProfile?.gender === "F" ? "Female" : "",
    abha: abhaProfile?.ABHANumber || "",
    abha_address: abhaProfile?.preferredAbhaAddress || "",
    abha_status: abhaProfile?.status || "",
    state_lgd: abhaProfile?.stateCode || "",
    district_lgd: abhaProfile?.districtCode || "",
    pincode: abhaProfile?.pincode || "",
    address: abhaProfile?.address || "",
    marital_status: "",

    // Habits
    habit_smoking: "no",
    habit_smoking_duration: "",

    habit_smokeless: "no",
    habit_smokeless_duration: "",
    
    habit_betelnut_with_tobacco: "no",
    habit_betelnut_with_tobacco_duration: "",

    habit_alcohol: "no",
    habit_alcohol_duration: "",

    // Comorbidities
    como_diabetes: "no",
    como_diabetes_duration: "",

    como_hypertension: "no",
    como_hypertension_duration: "",

    como_ischemic_heart_disease: "no",
    como_ischemic_heart_disease_duration: "",

    como_asthma_copd: "no",
    como_asthma_copd_duration: "",

    como_stroke: "no",
    como_stroke_duration: "",

    como_chronic_hepatitisb: "no",
    como_chronic_hepatitisb_duration: "",

    como_msald: "no",
    como_msald_duration: "",

    como_hiv_aids: "no",
    como_hiv_aids_duration: "",

    como_hypothyroidism: "no",
    como_hypothyroidism_duration: "",

    como_others: "no",
    como_others_duration: "",

    // Family Cancer History
    history_family_cancer: "no",
    history_site_of_tumor: "",
    history_relation: "",
    history_specify_relation: "",
});
